/* ZELVORA BEAUTY - theme.js */
(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  var money = function (cents) {
    var fmt = (window.ZELVORA && window.ZELVORA.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var productJson = form.getAttribute('data-product-json');
    var product; try { product = JSON.parse(document.getElementById(productJson).textContent); } catch (e) { return; }
    var variantSelect = form.querySelector('[name="id"]');
    var planRadios = form.querySelectorAll('[name="purchase_type"]');
    var planSelect = form.querySelector('[data-plan-select]');
    var planInput = form.querySelector('[name="selling_plan"]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare]');
    var msg = form.querySelector('[data-form-message]');
    var btn = form.querySelector('[type="submit"]');

    function currentVariant() {
      var id = parseInt(variantSelect.value, 10);
      return product.variants.filter(function (v) { return v.id === id; })[0];
    }
    function currentPlanId() {
      var sub = form.querySelector('[name="purchase_type"][value="subscribe"]');
      if (sub && sub.checked && planSelect) return planSelect.value;
      return '';
    }
    function render() {
      var v = currentVariant(); if (!v) return;
      var planId = currentPlanId();
      var price = v.price, compare = v.compare_at_price;
      if (planId && v.selling_plan_allocations) {
        var alloc = v.selling_plan_allocations.filter(function (a) { return String(a.selling_plan_id) === String(planId); })[0];
        if (alloc) { price = alloc.per_delivery_price || alloc.price; compare = v.price; }
      }
      if (planInput) planInput.value = planId;
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) { if (compare && compare > price) { compareEl.textContent = money(compare); compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (btn) { btn.disabled = !v.available; var sp = btn.querySelector('span'); if (sp) sp.textContent = v.available ? btn.getAttribute('data-add-text') : btn.getAttribute('data-soldout-text'); }
      var subBox = form.querySelector('[data-plan-box]');
      if (subBox) subBox.hidden = !planId;
    }
    if (variantSelect) variantSelect.addEventListener('change', render);
    planRadios.forEach(function (r) { r.addEventListener('change', render); });
    if (planSelect) planSelect.addEventListener('change', render);
    render();

    var mainImg = document.querySelector('[data-main-image]');
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.getAttribute('data-src'); mainImg.srcset = ''; }
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var payload = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }] };
      var sp = fd.get('selling_plan'); if (sp) payload.items[0].selling_plan = sp;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          if (!res.ok) { if (msg) msg.textContent = res.j.description || res.j.message || 'Could not add to cart.'; return; }
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-count', cart.item_count); });
            window.location.href = '/cart';
          });
        })
        .catch(function () { btn.disabled = false; if (msg) msg.textContent = 'Something went wrong. Please try again.'; });
    });
  });

  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { input.closest('form').submit(); });
  });
})();

/* Customer video wall */
(function () {
  var cards = document.querySelectorAll('.video-card');
  if (!cards.length) return;
  function stopAll(except) {
    cards.forEach(function (c) {
      if (c === except) return;
      var v = c.querySelector('[data-video]');
      if (v) { v.pause(); }
      c.classList.remove('is-playing');
    });
  }
  cards.forEach(function (card) {
    var video = card.querySelector('[data-video]');
    var play = card.querySelector('[data-video-play]');
    var sound = card.querySelector('[data-video-sound]');
    if (!video) return;

    function syncSoundIcon() {
      if (!sound) return;
      var on = sound.querySelector('[data-sound-on]'), off = sound.querySelector('[data-sound-off]');
      if (on && off) { on.hidden = video.muted; off.hidden = !video.muted; }
    }
    function start(withSound) {
      stopAll(card);
      video.muted = !withSound;
      if (sound) { sound.hidden = false; }
      syncSoundIcon();
      var p = video.play();
      if (p && p.catch) p.catch(function () { video.muted = true; syncSoundIcon(); video.play().catch(function () {}); });
      card.classList.add('is-playing');
    }
    if (play) play.addEventListener('click', function () { start(true); });
    video.addEventListener('click', function () {
      if (card.classList.contains('is-playing')) { video.pause(); card.classList.remove('is-playing'); }
      else { start(true); }
    });
    if (sound) sound.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      syncSoundIcon();
    });
    if (window.matchMedia('(hover:hover) and (min-width:960px)').matches) {
      card.addEventListener('mouseenter', function () {
        if (card.classList.contains('is-playing')) return;
        video.muted = true; video.play().catch(function () {});
      });
      card.addEventListener('mouseleave', function () {
        if (card.classList.contains('is-playing')) return;
        video.pause(); video.currentTime = 0;
      });
    }
  });
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) {
          var v = e.target.querySelector('[data-video]');
          if (v) v.pause();
          e.target.classList.remove('is-playing');
        }
      });
    }, { threshold: 0.25 });
    cards.forEach(function (c) { vio.observe(c); });
  }
})();
